import React from 'react';
import { useNavigate } from 'react-router-dom';
import { truncatePartyNames } from "./TruncateParties"

export const ClientCaseComponent = ({ caseData }) => {
    const navigate = useNavigate();
    const { caseId, data, error } = caseData;
    if (error) return <div className="caseids error">Error loading case ({caseId})</div>;
    return (
        <div
            className="caseids"
            onClick={() => navigate(`/home/cases/casedetails/${caseId}`)}
            style={{ cursor: 'pointer', padding: '8px', borderBottom: '1px solid #ccc' }}
        >
            {truncatePartyNames(data?.case?.parties)} - ({caseId})
        </div>
    );
};
